module.exports = __webpack_public_path__ + "img/caret-down.d7c51f04.svg";